import React, { useState, useCallback, useEffect } from 'react';
import { message } from '@/components';
import { useIntl } from 'umi';
import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';

export interface HostChangeResp {
  hostDeviceId: string;
  hostUid: string;
}

export default function useHostChange() {
  const meeting = useLocalStore(() => meetingModel);
  const { formatMessage } = useIntl();

  const hostChange = useCallback(
    (body: HostChangeResp) => {
      const { hostDeviceId, hostUid } = body;
      const user = meeting.getMemberInfoByMid(hostUid + hostDeviceId);
      user?.yxUid && meeting.setHostUid(hostUid + hostDeviceId);
      if (user) {
        message.info({
          content: formatMessage({ id: 'NEW_HOST' }, { name: user?.memberName }),
          noIcon: true,
        });
      }
    },
    [meeting]
  );

  return hostChange;
}
